import { render, staticRenderFns } from "./MLHReportPage.vue?vue&type=template&id=6acc64b4"
import script from "./MLHReportPage.vue?vue&type=script&lang=js"
export * from "./MLHReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports